<ifr-page-title pageTitle="'LEFT_PANEL_MY_INFORMATION' | translate "/>

<information-container />

<iflx-scroll-up-directive></iflx-scroll-up-directive>
